import { useEffect } from "react";

import { useCurrentStateAndParams } from "@uirouter/react";
import { useDispatch } from "react-redux";

import useSetTimeout from "app/pages/sales-intelligence/hooks/useSetTimeout";
import { toggleOpportunityListModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { proNavigator } from "single-spa/react-app/ProNavigator";

const LIST_MODAL_OPEN_DELAY = 1000;

function useCreateMyListModalInitialOpen() {
    const dispatch = useDispatch();
    const { params } = useCurrentStateAndParams<{ openAddList: "true" }>();

    const timeout = useSetTimeout();

    useEffect(() => {
        if (params.openAddList !== "true") {
            return;
        }

        timeout(() => {
            proNavigator.updateQueryParams(
                { openAddList: undefined },
                {
                    reload: false,
                    replace: true,
                },
            );

            dispatch(toggleOpportunityListModal(true));
        }, LIST_MODAL_OPEN_DELAY);
    }, [params]);
}

export default useCreateMyListModalInitialOpen;
